<template>
    <div class="request__history">
        <app-container-loading :show="isLoading" text="Carregando registro do pedido..."></app-container-loading>
        <div v-if="requestLogs && requestLogs.list && requestLogs.list.length">
            <app-perfect-scrollbar class="scrollbar">
                <div class="header" >
                    <h3 style="display: flex; align-items: center;">
                        <a href="javascript:void(0)" @click="loadRequestLogs(requestId)" style="margin-right: 8px; position: relative; top: 1px">
                            <i style="font-size: 24px" class="mi mi-refresh"></i>
                        </a>
                        Registro do pedido - {{ requestLogs.total }}
                    </h3>
                    <div style="margin-right: 15px; cursor: pointer;" @click="closeRequestLog()">X</div>
                </div>
                <div class="timeline">
                    <div class="entry" v-for="requestLog of requestLogs.list" :key="requestLog.log.id">
                        <div class="title" style="justify-content: space-between; flex-direction: column; display: flex;">
                            <div>
                                <h3>{{ requestLog.log.dateUpdated ? moment(requestLog.log.dateUpdated).local().format("DD/MM/YYYY HH:mm") : '---' }}</h3>
                                <p style="font-weight: bold;">Criado às:</p>
                                <p>{{ requestLog.log.dateCreated ? moment(requestLog.log.dateCreated).local().format("DD/MM/YYYY HH:mm") : '---' }}</p>
                                <p style="font-weight: bold;">Salvo por:</p>
                                <p>{{ VXORM.User.query().find(requestLog.log.saveBy) 
                                    ? utils.toTitleizeString(VXORM.User.query().find(requestLog.log.saveBy).name) 
                                    : '---' }}</p>
                                <p style="font-weight: bold;">Status do pedido:</p>
                                <p>{{ requestLog.log.requestStatus ? translateRequestStatus(requestLog.log.requestStatus) : '---' }}</p>
                                <p style="font-weight: bold;">Ação:</p>
                                <p>{{ requestLog.log.action === 'update' ? 'Atualizado' : 'Criado' }}</p>
                            </div>
                        </div>
                        <div class="body">
                            <div>

                            </div>
                            <div
                                class="table" style="margin-bottom: 10px;"
                            >
                                <table style="width: 100%;">
                                    <thead>
                                        <tr>
                                            <th>Detalhes do registro</th>
                                        </tr>
                                    </thead>
                                    <tbody  v-if="requestLog.log.action == 'create'">
                                        <tr>
                                            <td>
                                                Pedido criado às {{ moment(requestLog.log.dateCreated).format("DD/MM/YYYY HH:mm") }} por 
                                                {{ VXORM.User.query().find(requestLog.log.saveBy) 
                                                    ? utils.toTitleizeString(VXORM.User.query().find(requestLog.log.saveBy).name) 
                                                    : '---' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="requestLog.diff && !requestLog.error" >
                                        <tr v-for="(diff, index) of translateDiffs(requestLog.diff)" :key="index">
                                            <td v-show="diff.message" :class="diff.action" style="text-align: center">{{ diff.message }}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="requestLog.error">
                                        <tr>
                                            <td>Não foi possível obter os detalhes desse registro.</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else-if="!requestLog.diff">
                                        <tr>
                                            <td>Nada foi alterado.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div class="entry" v-if="total > offset">
                        <div class="title">
                            <a href="javascript:void(0)" @click="getRequestHistory()" style="position: relative; top: 12px;">Carregar mais</a>
                        </div>
                    </div> -->

                    <div style="display: flex; justify-content: center;">
                        <app-pagination :currentPage="currentPage" :totalPages="getTotalPages" @pagechanged="onPageChange"></app-pagination>
                    </div>
                </div>
            </app-perfect-scrollbar>
        </div>
        <div v-else>
            <div class="header" >
                <h3 style="display: flex; align-items: center;">
                    {{ 'Não há nenhum registro desse pedido.' }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex'
    import _ from 'lodash'
    import Vue from 'vue'
    import shortid from 'shortid'
    import moment from 'moment'
    import DifferenceInterpreter from './DifferenceInterpreter'
    import PaginationComponent from '../../../../../components/Utilities/Pagination.vue'

    import ContactAPI from '../../../../../api/contacts'
    import CashierBalacingAPI from '../../../../../api/cashier-balancing'
    import RequestsAPI from '../../../../../api/requests'
    import { isObject } from '@turf/turf';

    export default {
        props: ['requestId'],
        mixins: [DifferenceInterpreter],
        components: {
            'app-pagination': PaginationComponent
        },
        data(){
            return {
                isLoading: false,
                requestLogs: {},
                requestStatus: [
                    { name: 'pendente', type: 'pending' },
                    { name: 'enviado', type: 'sent' },
                    { name: 'em preparo', type: 'in-provision' },
                    { name: 'em progresso', type: 'in-displacement' },
                    { name: 'finalizado', type: 'finished' },
                    { name: 'cancelado', type: 'canceled' },
                    { name: 'removido', type: 'removed' },
                ],
                limit: 10,
                offset: 0,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('auth', ['user']),
            getTotalPages() {
                if(!this.requestLogs.total) 
                    return 0 
                else 
                    return this.requestLogs.total <= this.limit 
                        ? 1 
                        : (!Number.isInteger(this.requestLogs.total / this.limit) 
                            ? Math.trunc(this.requestLogs.total / this.limit) 
                            : (this.requestLogs.total / this.limit) - 1) + 1
            }
        },
        methods: {
            ...mapActions("toast", ["showToast", "showError"]),
            translateDiffs(diff) {
                // in array items = - removed item / + added item / ~ diff array
                let array = []
                this.diffTraverses(diff, array)
                return array
            },
            getProductName(productId) {
                return this.VXORM.Product.query().find(productId).name
            },

            getServiceName(serviceId) {
                return this.VXORM.Service.query().find(serviceId).name
            },
            
            getPaymentMethodName(paymentMethodId) {
                return this.VXORM.PaymentMethod.query().find(paymentMethodId).name
            },

            async loadRequestLogs(requestId) {
                this.isLoading = true
                try {
                    const res = await RequestsAPI.getLogs(requestId, {
                        offset: this.offset,
                        limit: this.limit
                    })
                    this.requestLogs = res.data
                    console.log(res.data)
                }
                catch(err) {
                    console.log(err)
                    this.showError('Não foi possível carregar o registro do pedido.')
                }
                finally {
                    this.isLoading = false
                }
            },

            translateRequestStatus(status) {
                return this.requestStatus.filter(value => value.type === status)[0].name
            },

            diffTraverses(diff, array) {
                diff = this.utils.removeReactivity(diff)
                for(let key in diff) {
                    if(isObject(diff[key])) {
                        if(key === 'request') 
                            this.diffInterpreterRequest(diff[key], array)
                        if(key === 'requestOrder')
                            this.diffInterpreterRequestOrder(diff[key], array)
                        if(key === 'responsibleUser')
                            this.diffInterpreterResponsibleUser(diff[key], array)
                        if(key === 'requestContact')
                            this.diffInterpreterRequestContact(diff[key], array)
                        this.diffTraverses(diff[key], array)
                    }
                    else if(diff[key] && Array.isArray(diff[key])) {
                        diff[key].forEach(values => {
                            let op = values[0]    
                            let obj = values[1]

                            // REMOVED
                            if(op === '-') 
                                array.push({ 
                                    message: `Removeu ${this.translateKeysOfRequest(key, obj)}`, 
                                    action: 'removed',
                                })
                            // EDITED
                            else if(op === '~') {
                                array.push({ 
                                    message: `${this.translateKeysOfRequest(key, obj)}`, 
                                    isSection: true, 
                                    action: 'edited',
                                })
                                if(key === 'requestOrderPayments')
                                    this.diffInterpreterRequestOrderPayments(obj, array)
                                if(key === 'requestOrderProducts')
                                    this.diffInterpreterRequestOrderProducts(obj, array)
                                if(key === 'requestOrderServices')
                                    this.diffInterpreterRequestOrderServices(obj, array)
                            }
                            // ADDED
                            else if(op === '+') {
                                array.push({
                                    message: `Adicionou ${this.translateKeysOfRequest(key, obj)}`,
                                    isSection: true,
                                    action: 'added',
                                })
                            }
                            // I DON´T KNOW
                            // else if(op === ' ') 
                            //     array.push({ 
                            //         message: `Algo aconteceu com ${this.translateKeysOfRequest(key)}`, 
                            //     })
                        })
                    }
                }
            },

            translateKeysOfRequest(key, obj) {
                switch(key) {
                    case 'requestOrderPayments': 
                        return 'Método de pagamento ' + this.getFieldName(key, obj, 'paymentMethod')
                    case 'requestOrderProducts': 
                        return 'Produto ' + this.getFieldName(key, obj, 'product')
                    case 'requestOrderServices':
                        return 'Serviço ' + this.getFieldName(key, obj, 'service') 
                    case 'responsibleUser': 
                        return 'Usuário responsável'
                    case 'contactPhones': 
                        return 'Telefone do contato'
                    case 'contactAddresses':
                        return 'Endereço do contato'
                    default: 
                        return ''
                }
            },

            getFieldName(key, obj, field = null) {
                if(!field) {
                    switch(key) {
                        case 'requestOrderServices': field = 'service'
                        case 'requestOrderProducts': field = 'product' 
                        case 'requestOrderPayments': field = 'paymentMethod'  
                        default: return ''
                    }
                }

                let fieldName = ''
                let fieldId = [`${field}Id`]
                if(obj) {
                    if(obj[field] && isObject(obj[field].name)) {
                        fieldName = obj[field].name.__old
                    }
                    else if(obj[field] && obj[field].name) {
                        fieldName = obj[field].name
                    }
                    else if(obj[fieldId]) {
                        fieldName = this.VXORM[this.utils.pascalCase(field)]
                            .find(obj[fieldId]).name
                    }
                }
                return fieldName
            },

            closeRequestLog() {
                this.$emit('closeRequestLog')
            },

            onPageChange(page) {
                this.currentPage = page
                this.offset = parseInt(`${page-1}0`)
                this.loadRequestLogs(this.requestId)
            },
        },
        async mounted(){
            await this.loadRequestLogs(this.requestId)
        }
    }
</script>

<style lang="scss" scoped>
    .request__history {
        width: 100%;
        $gutter: 20px;
        $border-width: 3px;
        $dot-diameter: 18px;
        background-color: var(--bg-color--2);
        table {
            margin: 0!important;
        }
        .scrollbar {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
        }
        div.header {
            padding: 20px 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .timeline {
            width:100%;
            padding: 20px 20px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 179px; //$gutter/2
                bottom: 0;
                width: $border-width;
                background: var(--font-color--primary);
            }
            &:after {
                content: "";
                display: table;
                clear: both;
            }
        }

        .entry:last-child {
            .body {
                border-bottom: 0;
            }
        }

        .entry {
            position: relative;
            display: flex;
            margin-bottom: 40px; 
            .title {
                flex-shrink: 0;
                padding-top: 5px;
                float: left;
                width: 160px;
                padding-right: $gutter;
                text-align: right;
                position: relative;
                &:before {
                    content: '';
                    position: absolute;
                    width: $dot-diameter;
                    height: $dot-diameter;
                    border: $border-width solid var(--font-color--primary);
                    background-color:#fff;
                    border-radius:100%;
                    top: 6px;
                    right: -$dot-diameter + ($dot-diameter / 2);
                    z-index: 99;
                }
                h3 {
                    margin: 0;
                    font-size: 120%;
                }
                p {
                    margin: 0;
                    font-size: 100%;
                }
            }
            .body {
                padding-left: 20px;
                padding-top: 2px;
                border-bottom: 0;
                flex-grow: 1;
                p {
                    line-height: 1.4em;
                    &:first-child {
                        margin-top: 0;
                        font-weight: 400;
                    }
                }
                ul {
                    color:#aaa;
                    padding-left: 0;
                    list-style-type: none;
                    li:before {
                        content: "–";
                        margin-right: .5em;
                    }
                }
            }
        }

    }
    .edited {
        color: rgb(204, 204, 146);
    }

    .added {
        color: rgb(137, 194, 137);
    }

    .removed {
        color: rgba(221, 146, 146, 0.932);
    }
</style>
